import React, { useMemo} from "react";
import { ExclamationTriangleIcon, XMarkIcon } from '@heroicons/react/24/outline';
import config from "../config";
import Helper from "../helpers";

const baseUrl = config.apiBaseUrl;
const ConfirmCancelSession = ({handleClose,Values}) => {
    let title = Values.title;
    let sessionId = Values.sessionId;
    //let sessionTime = new Date(Values.sessionDateTime);
    const sessionTime = useMemo(() => new Date(Values.sessionDateTime), [Values.sessionDateTime]);

    const [message, setMessage] = React.useState("");
    const handleCancelSession = async () => {
        const token = await Helper.getCookie('wh-jwt');
        const response = await fetch(`${baseUrl}/api/sessions/book/delete/${sessionId}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            credentials: 'include'
        });
        if (response.ok) {
            handleClose();
            window.location.reload();
        }

    };

    useMemo(() => {
        const now = new Date();
        const timeDiff = sessionTime - now;
        const hoursDiff = timeDiff / (1000 * 60 * 60);
        if (hoursDiff < 24) {
            setMessage("You will lose the token for this session as it is within 24 hours.");
        }
    }, [sessionTime]);

    return (
        <div className="card-luxury p-6 sm:p-8 max-w-2xl mx-auto animate-slide-up">
            {/* Header */}
            <div className="flex justify-between items-start mb-6">
                <div className="flex items-start gap-3">
                    <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-performance-pulse/10 border border-performance-pulse/30 flex items-center justify-center">
                        <ExclamationTriangleIcon className="h-6 w-6 text-performance-pulse" />
                    </div>
                    <div>
                        <h2 className="text-2xl sm:text-3xl font-display font-bold text-gradient-emerald mb-2">
                            Cancel Session
                        </h2>
                        <p className="text-sm text-emerald-600/70 font-body">
                            This action cannot be undone
                        </p>
                    </div>
                </div>
                <button
                    onClick={handleClose}
                    className="text-emerald-600/60 hover:text-emerald-300 transition-colors duration-300"
                >
                    <XMarkIcon className="h-6 w-6" />
                </button>
            </div>

            {/* Warning Message */}
            <div className="mb-6 p-4 glass-luxury rounded-xl border border-accent-platinum/20 bg-gradient-to-br from-luxury-slate/40 to-luxury-obsidian/60">
                <p className="text-base sm:text-lg text-accent-platinum font-body">
                    Are you sure you want to cancel the session <span className="font-display font-bold text-emerald-300">{title}</span>?
                </p>
            </div>

            {/* 24-Hour Warning */}
            {message && (
                <div className="mb-6 p-4 glass-luxury rounded-xl border border-performance-pulse/30 bg-gradient-to-br from-performance-pulse/5 to-luxury-obsidian/80">
                    <div className="flex items-start gap-3">
                        <ExclamationTriangleIcon className="h-5 w-5 text-performance-pulse flex-shrink-0 mt-0.5" />
                        <p className="text-sm sm:text-base text-performance-pulse font-body font-medium">
                            {message}
                        </p>
                    </div>
                </div>
            )}

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 mt-8">
                <button
                    onClick={handleClose}
                    className="btn-outline flex-1 order-2 sm:order-1"
                >
                    Keep Session
                </button>
                <button
                    onClick={handleCancelSession}
                    className="btn-secondary text-performance-pulse border-performance-pulse/50 hover:border-performance-pulse/80 hover:shadow-[0_0_30px_rgba(255,7,58,0.25)] flex-1 order-1 sm:order-2 flex items-center justify-center gap-2"
                >
                    <ExclamationTriangleIcon className="h-5 w-5" />
                    <span>Cancel Session</span>
                </button>
            </div>
        </div>
    );
}

export default ConfirmCancelSession;
